import { Entry } from 'contentful';

import { ProductCatalog } from './models/ProductCatalog';

import { contentfulApi } from 'common/api/utils/contentful';
import { APIResponse } from 'common/api/models';

export const getProductCatalog = (entryId: string): Promise<APIResponse<Entry<ProductCatalog>>> =>
    contentfulApi.getEntry<ProductCatalog>(entryId);
